import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProcedureMoveAppBar from "../../../common/ProcedureMoveAppBar.js";
import Snackbar from "../../../common/Snackbar.js";
import { moveStep } from "../../../redux/stepSlice.js";
import { copyElement } from "../../../redux/sectionSlice.js";
import { generateSHA256 } from "../../../util/generateSHA256.js";
import { getPages, renderPreview, renderVideo } from "../plugins/utils.js";
import {
  applyTransparency,
  calculateGroupHeight,
  calculateTextBlockWidth,
  estimateKonvaTextHeight,
  formatListContent,
  getTextStyle,
  hasNoteContent,
  hasTaskContent,
  hasUserContent,
  measureHtmlHeight,
  stripHtmlPreserveFormatting,
} from "../plugins/utils.js";
import RectangleElement from "../../Canvas/components/rectangle/RectangleElement.jsx";
import ArrowElement from "../../Canvas/components/arrow/ArrowElement.jsx";
import CircleElement from "../../Canvas/components/circle/CircleElement.jsx";
import LineElement from "../../Canvas/components/line/LineElement.jsx";
import CanvasImage from "../../Canvas/components/canvas-core/CanvasImage.jsx";
import TextElement from "../../Canvas/components/text/TextElement.jsx";
import DoubleSidedArrowElement from "../../Canvas/components/arrow/DoubleSidedArrowElement.jsx";
import CanvasDisplay from "../../Canvas/components/canvas-core/CanvasDisplay.jsx";
import { generateConfirmMoveMessage } from "../../SubassemblyDetails/utils/movePreviewUtils.js";
import RenderHtml from "../../../common/AppSpecificConpnents/PartsTable/RenderHtml.js";
import {
  extractVersionStructure,
  getAuditTrailData,
  prepareNewContent,
} from "../../../util/getAuditTrailData.js";
import { getRevAllNodes } from "../../../redux/procedureRevisionSlice.js";
import { getMoveCopyText } from "../../../util/AppUtils.js";
import {
  generateSourceTreePath,
  generateTargetTreePath,
  getDisplayIndex,
  getSubstepLetter,
  generateStatusText,
  validateAndCorrectTreePathData,
  generateCompleteTreePath,
  HeadingWithTreePath,
} from "../../SubassemblyDetails/utils/treePathUtils.js";
const ProcedureAttachmentMovePreview = () => {
  const { sections } = useSelector((state) => state.section);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let richTextCounter = 1;
  let canvasCounter = 1;
  let videoCounter = 1;
  let formCounter = 1;

  let substepCounter = 1;
  let stepCounter = 1;
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [auditData, setAuditData] = useState({
    user_ref: localStorage.getItem("user_id") || "",
    ip_address: "",
    device_info: navigator.userAgent,
    hash: generateSHA256(Math.random().toString()),
    signature: "",
  }); // Fetch IP address and generate hash

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) =>
        setAuditData((prev) => ({ ...prev, ip_address: data.ip }))
      )
      .catch((err) => console.error("Failed to fetch IP:", err));
  }, []);

  let richTextsCounter = {};
  let attachmentCounter = 1;
  const [isModalOpen, setModalOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });
  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    canvases,
    videos,
  } = useSelector((state) => state.step);

  const [selectedView, setSelectedView] = useState("new");

  // Handle view mode change
  const handleViewChange = (view) => {
    setSelectedView(view);
  };

  const {
    moveType,
    sourceSectionIndex,
    targetSectionIndex,
    revision,
    partNumber,
    type,
    sourceStepIndex,
    steps,
    targetStepIndex = 0, // Default value if not provided
    targetNodeIndex, // Add this missing variable
    partId,
    revisionId,
    fromStepId,
    fromSubstepTreeId,
    fromSubstepSiblingOrder,
    targetSectionData,
    fromSectionId,
    fromSubstepId,
    targetNodeType,
    elementTreeId,
    elementId,
    createCopy = false,
  } = location.state;
  const [previewSections, setPreviewSections] = useState([...sections]);
  const sortedSections = [...sections];

  const { allRevisionNodes } = useSelector((state) => state.procedureRevision);
  useEffect(() => {
    if (elementId) {
      dispatch(
        getRevAllNodes({
          partId: partId,
          revisionId: revisionId,
        })
      );
    }
  }, [dispatch, elementId, partId, revisionId]);

  // Ensure we have sourceStepId available
  useEffect(() => {
    // Make sure we have a valid sourceStepId
    if (
      location.state.movingNode &&
      !location.state.sourceStepId &&
      sourceStepIndex !== undefined
    ) {
      const sourceSectionId =
        sortedSections[sourceSectionIndex]?.section_tree_node_id;
      const sourceSteps = stepsBySection[sourceSectionId] || [];
      const sourceStep = sourceSteps[sourceStepIndex] || {};

      if (sourceStep.step_tree_node_id) {
        location.state.sourceStepId = sourceStep.step_tree_node_id;
      } else if (steps && steps.length > 0) {
        location.state.sourceStepId = steps[0].step_tree_node_id;
      }
    }
  }, [
    sourceStepIndex,
    sourceSectionIndex,
    stepsBySection,
    sortedSections,
    steps,
    location.state,
  ]);

  useEffect(() => {
    // Create preview of the move
    const newSections = [...sections];

    if (location.state.movingNode) {
      // For attachment moves, derive sourceStepId if not in location.state
      if (!location.state.sourceStepId && sourceStepIndex !== undefined) {
        // Get the source step and use its ID
        const sourceSectionId =
          sortedSections[sourceSectionIndex]?.section_tree_node_id;
        const sourceSteps = stepsBySection[sourceSectionId] || [];
        const sourceStep = sourceSteps[sourceStepIndex] || {};

        // Store it back in location.state for future reference
        location.state.sourceStepId = sourceStep.step_tree_node_id;
      }
    } else if (location.state.movingStep) {
      // For step moves, existing implementation
      const sourceSection = newSections[sourceSectionIndex];
      newSections.splice(sourceSectionIndex, 1);
      newSections.splice(targetSectionIndex, 0, sourceSection);
      setPreviewSections(newSections);
    } else {
      // Original section move logic
      const sourceSection = newSections[sourceSectionIndex];
      newSections.splice(sourceSectionIndex, 1);
      newSections.splice(targetSectionIndex, 0, sourceSection);
      setPreviewSections(newSections);
    }
  }, [
    sourceSectionIndex,
    targetSectionIndex,
    moveType,
    sourceStepIndex,
    location.state.targetStepIndex,
    location.state.targetNodeIndex,
    location.state.movingNode,
    location.state.movingStep,
  ]);

  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleConfirm = () => {
    setModalOpen(true);
  };

  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };

  const handleConfirmSave = async () => {
    if (!comment.trim()) {
      showSnackbar("Please enter a comment before confirming.", "error");
      return;
    }

    setIsModalLoading(true);
    try {
      // Prepare payload for moving attachment

      const attachmentId = location.state.elementId;
      const targetContainerId =
        targetSectionData?.substepId || targetSectionData?.stepId;

      let parent_version = Object.values(attachments)
        .flat()
        .find((a) => a.attachment_tree_node_id === attachmentId);

      const newContent = prepareNewContent({
        allRevisionNodes,
        fromInfo: {
          fromSectionId,
          fromStepId,
          fromSubstepId,
          nodeId: attachmentId,
        },
        toInfo: { ...targetSectionData },
        moveType,
        node_id_key: "attachment_tree_node_id",
      });
      const audit_trail_data = await getAuditTrailData(
        {
          action: createCopy ? "ATTACHMENT_COPIED" : "ATTACHMENT_MOVED",
          comment: comment,
          parent_version: parent_version ? parent_version.version_id_ref : null,
          version_content: {
            action_to_show: getMoveCopyText(
              location.state.move_rev_node_info,
              partNumber,
              revision
            ),
            originingalContent: extractVersionStructure(allRevisionNodes),
            newContent: newContent,
            moveType,
            rev: revision,
            status: location.state.status,
            type,
            item_code_type: type,
            partNumber,
          },
        },
        false
      );

      const stepData = {
        from_procedure_tree_node_ref: elementTreeId,
        from_order: parseInt(fromSubstepSiblingOrder),
        from_type: "attachment",
        from_part_id_ref: partId,
        from_procedure_rev_ref: revisionId,
        from_section_id_ref: fromSectionId,
        from_step_id_ref: fromStepId,
        from_substep_id_ref:
          fromSubstepId === "null" || fromSubstepId === null
            ? ""
            : fromSubstepId,
        to_procedure_tree_node_ref: targetSectionData?.elementTreeId,
        to_order: (() => {
          // For "into" moves, this will be calculated later
          if (moveType === "into") {
            return 0; // Placeholder, will be calculated below
          }

          // CRITICAL FIX: Use the expectedSiblingOrder that was calculated in the move function
          // This ensures the save logic matches exactly what the preview shows
          if (
            location.state.expectedSiblingOrder !== undefined &&
            location.state.expectedSiblingOrder !== null
          ) {
            return location.state.expectedSiblingOrder;
          }

          // Fallback: use the base order calculation if expectedSiblingOrder is not available
          const baseOrder = parseInt(
            targetSectionData?.elementSiblingOrder ||
              targetSectionData?.substepSiblingOrder ||
              targetSectionData?.stepSiblingOrder ||
              1
          );

          if (moveType === "up") {
            return baseOrder;
          } else if (moveType === "below") {
            const result = baseOrder + 1;

            return result;
          }

          return baseOrder;
        })(),
        to_type: "attachment", // Always use the source item type (attachment), not the target type
        to_part_id_ref: partId,
        to_procedure_rev_ref: revisionId,
        to_section_id_ref: targetSectionData?.sectionId,
        to_step_id_ref: targetSectionData?.stepId,
        to_substep_id_ref:
          targetSectionData?.substepId === "null" ||
          targetSectionData?.substepId === null
            ? ""
            : targetSectionData?.substepId,
        from_child_node_ref: attachmentId,
        to_child_node_ref: targetSectionData?.elementId,
        // Set direction_move_into to true when moving between different steps/substeps
        direction_move_into: Boolean(
          moveType === "into" ||
            fromStepId !== targetSectionData?.stepId ||
            (fromSubstepId &&
              targetSectionData?.substepId &&
              fromSubstepId !== targetSectionData?.substepId)
        ),
        direction:
          moveType === "up"
            ? createCopy
              ? "paste_up"
              : "move_up"
            : moveType === "below"
            ? createCopy
              ? "paste_down"
              : "move_down"
            : createCopy
            ? "paste_down"
            : "move_down",
        ...(createCopy ? {} : { create_copy: createCopy }), // Only add create_copy for move operations
        audit_trail_data,
      };

      if (moveType === "into") {
        // For moving into, we need to calculate the highest sibling_order in the target container
        // and set to_order to (highest + 1) to place the rich text at the end

        // Get all items in the target container
        let targetItems = [];

        if (targetSectionData?.substepId) {
          // If target is a substep, get all items in that substep
          targetItems = [
            ...(richTexts[targetContainerId] || []),
            ...(forms[targetContainerId] || []),
            ...(attachments[targetContainerId] || []),
            ...(canvases[targetContainerId] || []),
            ...(videos[targetContainerId] || []),
          ];
        } else if (targetSectionData?.stepId) {
          // If target is a step, get all items in that step (excluding substep items)
          const allStepItems = [
            ...(richTexts[targetContainerId] || []),
            ...(forms[targetContainerId] || []),
            ...(attachments[targetContainerId] || []),
            ...(canvases[targetContainerId] || []),
            ...(videos[targetContainerId] || []),
          ];

          // Filter out items that belong to substeps
          targetItems = allStepItems.filter(
            (item) => !item.substep_id_ref && !item.sub_step_tree_node_id
          );
        }

        // Find the highest sibling_order in the target items
        let highestOrder = 0;
        targetItems.forEach((item) => {
          const order = parseInt(
            item.sibling_order || item.procedure_tree?.sibling_order || 0
          );
          if (!isNaN(order) && order > highestOrder) {
            highestOrder = order;
          }
        });

        // Set to_order to highest + 1 (or at least 1 if no items)
        stepData.to_order = Math.max(1, highestOrder + 1);
      }
      // Clean up empty or null substep ref
      if (!stepData.from_substep_id_ref) {
        delete stepData.from_substep_id_ref;
      }

      // Clean up empty or null substep ref
      if (!stepData.to_substep_id_ref) {
        delete stepData.to_substep_id_ref;
      }

      // if (moveType === "up") {
      //   stepData.to_order =
      //     parseInt(
      //       targetSectionData?.elementSiblingOrder ||
      //         targetSectionData?.substepSiblingOrder ||
      //         targetSectionData?.stepSiblingOrder
      //     ) + 1;
      // }

      // Call API to update the attachment position
      if (createCopy) {
        // Use copyElement action for copy operations
        await dispatch(copyElement(stepData)).unwrap();
      } else {
        // Use moveStep action for move operations
        await dispatch(moveStep(stepData)).unwrap();
      }

      showSnackbar(
        createCopy
          ? "Attachment copied successfully!"
          : "Attachment moved successfully!",
        "success"
      );

      setModalOpen(false);
      navigate(-3); // Navigate back to the previous page
    } catch (error) {
      showSnackbar("Error moving: " + error?.message, "error");
    } finally {
      setIsModalLoading(false);
    }
  };

  const getReorderedStepsBySection = (
    stepsBySection,
    sortedSections,
    sourceSectionIndex,
    targetSectionIndex,
    sourceStepIndex,
    targetStepIndex,
    moveType,
    movingStep = false
  ) => {
    if (selectedView === "original") return stepsBySection;

    // Clone the existing structure to avoid mutating state directly
    const updatedStepsBySection = JSON.parse(JSON.stringify(stepsBySection));

    if (movingStep) {
      // Get the source section ID
      const sourceSectionId = sortedSections.find(
        (s) => s.section_tree_node_id === sourceSectionIndex
      )?.section_tree_node_id;
      if (!sourceSectionId) return updatedStepsBySection;

      // Get the target section ID
      const targetSectionId =
        sortedSections[targetSectionIndex].section_tree_node_id;

      // Get the source steps array and the step to move
      const sourceSteps = [...(updatedStepsBySection[sourceSectionId] || [])];
      if (sourceStepIndex >= sourceSteps.length) return updatedStepsBySection;

      // Remove step from source
      const [movedStep] = sourceSteps.splice(sourceStepIndex, 1);

      // Get the target steps array
      const targetSteps = [...(updatedStepsBySection[targetSectionId] || [])];

      // Handle different move types
      if (moveType === "into") {
        // Move to end of target section
        targetSteps.push(movedStep);
      } else if (moveType === "up") {
        // Insert before the target step
        targetSteps.splice(targetStepIndex, 0, movedStep);
      } else if (moveType === "below") {
        // Insert after the target step
        targetSteps.splice(targetStepIndex + 1, 0, movedStep);
      }

      // Update the mappings
      updatedStepsBySection[sourceSectionId] = sourceSteps;
      updatedStepsBySection[targetSectionId] = targetSteps;

      return updatedStepsBySection;
    } else {
      // Original section moving logic - just return the original for now
      // as we're only focusing on step movement
      const newStepsBySection = { ...stepsBySection };
      return newStepsBySection;
    }
  };

  const updated = getReorderedStepsBySection(
    stepsBySection,
    sections,
    sourceSectionIndex,
    targetSectionIndex,
    sourceStepIndex,
    location.state.targetStepIndex,
    moveType,
    location.state.movingStep
  );

  const updatedSubstepsByStep = substepsByStep;

  // Set up the preview data for the UI
  const updatedSteps = location.state.movingStep
    ? getReorderedStepsBySection(
        stepsBySection,
        sections,
        sourceSectionIndex,
        targetSectionIndex,
        sourceStepIndex,
        location.state.targetStepIndex,
        moveType,
        location.state.movingStep
      )
    : stepsBySection;

  const getReorganizedContentItems = (
    allContentItems, // { stepId or substepId: array of items }
    sourceStepId, // The ID of the step the source item belongs to
    targetStepId, // The ID of the step the target item belongs to
    sourceNodeIndex, // The index of the item being moved within its source container (step/substep)
    targetNodeIndex, // The index of the target item within its target container (step/substep)
    moveType, // "up", "below", "into"
    nodeType // "richText", "form", "attachment", etc. (type of the *moved* item)
  ) => {
    // Assuming selectedView and location.state.movingNode are defined in the outer scope
    if (selectedView === "original" || !location.state.movingNode) {
      return allContentItems;
    }

    // --- Start of derived sourceStepId (from original code, assuming location.state variables are accessible) ---
    // These need to be passed in or reliably available in the scope where this function is called.
    // For this rewrite, we'll assume `location.state`, `sortedSections`, `stepsBySection`, `substepsByStep`, `steps` are accessible.
    // In a real application, you might consider passing them as parameters.

    // Fallback logic for sourceStepId if it's not directly provided
    // Ensure `sourceSectionIndex` is actually an index and related data structures exist.
    if (
      !sourceStepId &&
      typeof sourceSectionIndex !== "undefined" &&
      sortedSections &&
      stepsBySection
    ) {
      const sourceSectionId =
        sortedSections[sourceSectionIndex]?.section_tree_node_id;
      const sourceSteps = stepsBySection[sourceSectionId] || [];
      const sourceStep = sourceSteps[sourceStepIndex] || {};
      sourceStepId = sourceStep.step_tree_node_id;
    }

    if (!sourceStepId && targetStepId) {
      sourceStepId = targetStepId;
    }

    if (!sourceStepId && steps && steps.length > 0) {
      sourceStepId = steps[0].step_tree_node_id;
    }

    if (!sourceStepId || !targetStepId) {
      return allContentItems; // Return original items without changes
    }
    // --- End of derived sourceStepId ---

    // Deep clone the content items to avoid mutating the original state.
    const updatedItems = JSON.parse(JSON.stringify(allContentItems));

    // Determine the actual container IDs (stepId or substepId) for source and target.
    // This logic relies on `location.state.sourceSubstepIndex` and `location.state.targetSubstepIndex`.

    let sourceContainerId = sourceStepId;
    if (location.state.sourceSubstepIndex !== undefined) {
      const substeps = substepsByStep[sourceStepId] || [];
      const sourceSubstep = substeps[location.state.sourceSubstepIndex];
      sourceContainerId = sourceSubstep?.sub_step_tree_node_id || sourceStepId; // Fallback to stepId if substep not found
    }

    let targetContainerId = targetStepId;
    if (location.state.targetSubstepIndex !== undefined) {
      const substeps = substepsByStep[targetStepId] || [];
      const targetSubstep = substeps[location.state.targetSubstepIndex];
      targetContainerId = targetSubstep?.sub_step_tree_node_id || targetStepId; // Fallback to stepId if substep not found
    }

    // Define isTargetSubstep for use in filtering logic
    const isTargetSubstep = location.state.targetSubstepIndex !== undefined;

    // --- Handle Missing Source Container (Placeholder creation) ---
    // This logic creates a dummy item when the source item isn't yet in the data structure.
    // ONLY run this for placeholder creation, not for actual moves

    if (!sourceContainerId && targetContainerId && moveType === "into") {
      const placeholderItem = {
        type: nodeType === "rich_text" ? "richText" : nodeType, // Normalize rich_text to richText
        short_description: `Placeholder for moved ${nodeType} (from source index ${sourceNodeIndex})`,
        // Add unique IDs and dummy content based on nodeType
        ...(nodeType === "rich_text" || nodeType === "richText"
          ? {
              rich_text_node_id: `temp-richtext-${Date.now()}`,
              rich_text_content: "<p>Moved rich text content</p>",
              category_data: { category_name: "" },
            }
          : {}),
        ...(nodeType === "attachment"
          ? {
              attachment_tree_node_id: `temp-attachment-${Date.now()}`,
              attachments: [],
            }
          : {}),
        ...(nodeType === "form"
          ? { form_tree_node_id: `temp-form-${Date.now()}` }
          : {}),
        ...(nodeType === "canvas"
          ? { canvas_tree_node_id: `temp-canvas-${Date.now()}`, shapes: [] }
          : {}),
        ...(nodeType === "video"
          ? {
              video_tree_node_id: `temp-video-${Date.now()}`,
              video: "",
              video_url: "",
            }
          : {}),
      };

      // Assign substep ref if target is a substep
      if (location.state.targetSubstepIndex !== undefined) {
        placeholderItem.substep_id_ref = targetContainerId;
        placeholderItem.sub_step_tree_node_id = targetContainerId;
      } else {
        delete placeholderItem.substep_id_ref;
        delete placeholderItem.sub_step_tree_node_id;
      }

      let targetItems = updatedItems[targetContainerId] || [];

      // CRITICAL FIX: Sort targetItems by sibling order to match UI display order
      // This ensures the preview positioning matches what the user sees
      targetItems = targetItems.sort((a, b) => {
        // Get sibling orders, defaulting to empty string if not available
        const orderA = a.sibling_order || a.procedure_tree?.sibling_order || "";
        const orderB = b.sibling_order || b.procedure_tree?.sibling_order || "";

        // If both have sibling orders, compare them numerically
        if (orderA && orderB) {
          const orderCompare = compareSiblingOrders(orderA, orderB);
          if (orderCompare !== 0) return orderCompare;
        }

        // If only one has a sibling order, prioritize it
        if (orderA && !orderB) return -1;
        if (!orderA && orderB) return 1;

        // If no sibling orders, sort by created_at date if available
        const dateA = a.created_at ? new Date(a.created_at) : null;
        const dateB = b.created_at ? new Date(b.created_at) : null;

        if (dateA && dateB) return dateA - dateB; // Older items first

        // For consistent sorting when other methods fail, sort by type
        const typeOrder = {
          richText: 1,
          form: 2,
          attachment: 3,
          canvas: 4,
          video: 5,
        };
        return typeOrder[a.type] - typeOrder[b.type];
      });

      let insertionIndex = targetItems.length; // Default to end

      if (moveType === "into") {
        insertionIndex = targetItems.length; // Always append to end for "into"
      } else {
        // CRITICAL FIX: Use the same logic as video move preview for accurate positioning
        // For "up" or "below" moves, find the target item by ID and calculate correct position

        if (location.state.targetNodeId && location.state.targetNodeType) {
          // Find the target item by its ID in the target container

          const targetItem = targetItems.find((item) => {
            const itemId =
              item.rich_text_node_id ||
              item.form_tree_node_id ||
              item.attachment_tree_node_id ||
              item.canvas_tree_node_id ||
              item.video_tree_node_id;
            const isMatch = itemId === location.state.targetNodeId;
            return isMatch;
          });

          if (targetItem) {
            const targetItemIndex = targetItems.indexOf(targetItem);

            if (moveType === "up") {
              insertionIndex = targetItemIndex;
            } else if (moveType === "below") {
              insertionIndex = targetItemIndex + 1;
            }
          } else {
            // Fallback to using targetNodeIndex if target item not found by ID
            if (targetNodeIndex !== undefined && targetNodeIndex >= 0) {
              const allVisibleItems = targetItems.filter((item) => {
                const containerMatches = isTargetSubstep
                  ? item.sub_step_tree_node_id === targetContainerId
                  : !item.substep_id_ref && !item.sub_step_tree_node_id;
                return containerMatches;
              });

              if (targetNodeIndex < allVisibleItems.length) {
                const fallbackTargetItem = allVisibleItems[targetNodeIndex];
                const fallbackTargetIndex =
                  targetItems.indexOf(fallbackTargetItem);

                if (fallbackTargetIndex !== -1) {
                  if (moveType === "up") {
                    insertionIndex = fallbackTargetIndex;
                  } else if (moveType === "below") {
                    insertionIndex = fallbackTargetIndex + 1;
                  }
                }
              }
            }
          }
        } else {
          // Fallback: use the old logic if targetNodeId is not available
          if (targetNodeIndex !== undefined && targetNodeIndex >= 0) {
            const allVisibleItems = targetItems.filter((item) => {
              const containerMatches = isTargetSubstep
                ? item.sub_step_tree_node_id === targetContainerId
                : !item.substep_id_ref && !item.sub_step_tree_node_id;
              return containerMatches;
            });

            if (targetNodeIndex < allVisibleItems.length) {
              const targetItem = allVisibleItems[targetNodeIndex];
              const targetItemIndex = targetItems.indexOf(targetItem);

              if (targetItemIndex !== -1) {
                if (moveType === "up") {
                  insertionIndex = targetItemIndex;
                } else if (moveType === "below") {
                  insertionIndex = targetItemIndex + 1;
                }
              }
            }
          }
        }

        // Clamp insertionIndex to be within bounds or at the end
        insertionIndex = Math.min(
          Math.max(0, insertionIndex),
          targetItems.length
        );
      }

      targetItems.splice(insertionIndex, 0, placeholderItem);
      updatedItems[targetContainerId] = targetItems;
      return updatedItems;
    } else if (!sourceContainerId || !targetContainerId) {
      return updatedItems;
    }
    // --- End of Placeholder Item Handling ---

    const sourceItems = updatedItems[sourceContainerId] || [];

    // Ensure sourceNodeIndex is valid for the sourceItems array.
    if (sourceNodeIndex < 0 || sourceNodeIndex >= sourceItems.length) {
      return updatedItems;
    }

    // Handle copy vs move logic
    let itemToMove;
    if (createCopy) {
      // For copy, get the item without removing it from source
      itemToMove = sourceItems[sourceNodeIndex];
      if (!itemToMove) {
        return updatedItems;
      }

      // Create a deep copy of the item with a new unique ID
      itemToMove = JSON.parse(JSON.stringify(itemToMove));

      // Generate new unique IDs based on item type
      const timestamp = Date.now();
      if (itemToMove.attachment_tree_node_id) {
        itemToMove.attachment_tree_node_id = `${itemToMove.attachment_tree_node_id}_copy_${timestamp}`;
      }
      if (itemToMove.rich_text_node_id) {
        itemToMove.rich_text_node_id = `${itemToMove.rich_text_node_id}_copy_${timestamp}`;
      }
      if (itemToMove.form_tree_node_id) {
        itemToMove.form_tree_node_id = `${itemToMove.form_tree_node_id}_copy_${timestamp}`;
      }
      if (itemToMove.canvas_tree_node_id) {
        itemToMove.canvas_tree_node_id = `${itemToMove.canvas_tree_node_id}_copy_${timestamp}`;
      }
      if (itemToMove.video_tree_node_id) {
        itemToMove.video_tree_node_id = `${itemToMove.video_tree_node_id}_copy_${timestamp}`;
      }
    } else {
      // For move, remove the item from source
      const [removedItem] = sourceItems.splice(sourceNodeIndex, 1);
      if (!removedItem) {
        return updatedItems;
      }
      itemToMove = removedItem;
    }

    // Update the source container's items array only for move operations
    if (!createCopy) {
      updatedItems[sourceContainerId] = sourceItems;
    }

    // Prepare item for target: update substep references if moving to/from a substep.
    if (location.state.targetSubstepIndex !== undefined) {
      // Check if target is a substep context
      itemToMove.substep_id_ref = targetContainerId;
      itemToMove.sub_step_tree_node_id = targetContainerId;
    } else {
      // If target is a step context, ensure no substep references are left
      delete itemToMove.substep_id_ref;
      delete itemToMove.sub_step_tree_node_id;
    }

    const targetItems = updatedItems[targetContainerId] || [];

    // When moving above/below, we need to consider ALL items in the container, not just items of the same type
    // This is because we want to position relative to the target item regardless of its type
    const visibleTargetItems = targetItems.filter((item) => {
      const containerMatches = isTargetSubstep
        ? item.sub_step_tree_node_id === targetContainerId
        : !item.substep_id_ref && !item.sub_step_tree_node_id;
      return containerMatches;
    });

    // Determine the insertion index in the target array based on moveType and targetNodeIndex.
    let insertionIndex = targetItems.length; // Default for "into" move or invalid targetNodeIndex

    if (moveType === "into") {
      insertionIndex = targetItems.length; // Always append to the end for "into" moves
    } else {
      // CRITICAL FIX: For Canvas targets, always use Canvas-specific positioning regardless of targetNodeIndex
      if (location.state.targetNodeType === "Canvas") {
        const canvasItems = visibleTargetItems.filter(
          (item) => item.type === "canvas"
        );

        if (canvasItems.length > 0) {
          // Use the first Canvas as the target
          const targetCanvas = canvasItems[0];
          const canvasIndex = targetItems.indexOf(targetCanvas);

          if (canvasIndex !== -1) {
            if (moveType === "up") {
              insertionIndex = canvasIndex;
            } else if (moveType === "below") {
              insertionIndex = canvasIndex + 1;
            }
          }
        }
      } else if (targetNodeIndex !== undefined && targetNodeIndex >= 0) {
        // CRITICAL FIX: Use targetNodeId to find the correct item instead of relying on targetNodeIndex
        const targetNodeId = location.state.targetNodeId;
        let targetItem = null;
        let targetItemIndex = -1;

        if (targetNodeId) {
          // Find the target item by its ID in the targetItems array
          targetItem = targetItems.find((item) => {
            if (!item) return false;
            const itemId =
              item.video_tree_node_id ||
              item.rich_text_node_id ||
              item.form_tree_node_id ||
              item.canvas_tree_node_id ||
              item.attachment_tree_node_id;
            return itemId === targetNodeId;
          });

          if (targetItem) {
            targetItemIndex = targetItems.indexOf(targetItem);
          }
        }

        // Fallback to targetNodeIndex if ID lookup failed
        if (
          targetItemIndex === -1 &&
          targetNodeIndex < visibleTargetItems.length
        ) {
          targetItem = visibleTargetItems[targetNodeIndex];
          targetItemIndex = targetItems.indexOf(targetItem);
        }

        if (targetItemIndex !== -1) {
          if (moveType === "up") {
            insertionIndex = targetItemIndex;
          } else if (moveType === "below") {
            insertionIndex = targetItemIndex + 1;
          }
        }
        // Ensure insertionIndex is within valid array bounds (0 to targetItems.length)
        insertionIndex = Math.min(
          Math.max(0, insertionIndex),
          targetItems.length
        );
      } else {
        // For non-Canvas targets, try global number fallback if targetNodeIndex is invalid

        const targetGlobalNumber = location.state.targetNodeGlobalNumber;
        if (targetGlobalNumber && visibleTargetItems.length > 0) {
          // Try to find an item with matching global number
          const matchingItem = visibleTargetItems.find(
            (item) =>
              item.globalNodeNumber === targetGlobalNumber ||
              parseInt(item.nodeIndex) === parseInt(targetGlobalNumber)
          );

          if (matchingItem) {
            const matchIndex = targetItems.indexOf(matchingItem);
            if (matchIndex !== -1) {
              if (moveType === "up") {
                insertionIndex = matchIndex;
              } else if (moveType === "below") {
                insertionIndex = matchIndex + 1;
              }
            }
          } else {
            // If no match, use first item as fallback
            const firstItem = visibleTargetItems[0];
            const firstIndex = targetItems.indexOf(firstItem);

            if (firstIndex !== -1) {
              if (moveType === "up") {
                insertionIndex = firstIndex;
              } else if (moveType === "below") {
                insertionIndex = firstIndex + 1;
              }
            }
          }
        } else {
        }
      }

      // Enhanced positioning logic for better accuracy
      if (
        insertionIndex === targetItems.length &&
        location.state.targetNodeType
      ) {
        // Look for the target item by its type and properties
        const targetItemType = location.state.targetNodeType.toLowerCase();
        const targetItemId = location.state.targetNodeId;

        if (targetItemId) {
          // Try to find by ID first
          const targetById = targetItems.find((item) => {
            if (!item) return false;
            const itemId =
              item.video_tree_node_id ||
              item.rich_text_node_id ||
              item.form_tree_node_id ||
              item.canvas_tree_node_id ||
              item.attachment_tree_node_id;
            return itemId === targetItemId;
          });

          if (targetById) {
            const targetIndex = targetItems.indexOf(targetById);
            if (targetIndex !== -1) {
              insertionIndex =
                moveType === "up" ? targetIndex : targetIndex + 1;
            }
          }
        }

        // If still no match, try by type and global number
        if (
          insertionIndex === targetItems.length &&
          location.state.targetNodeGlobalNumber
        ) {
          const targetByType = targetItems.find((item) => {
            if (!item) return false;
            const itemType =
              item.type ||
              (item.video_tree_node_id
                ? "video"
                : item.rich_text_node_id
                ? "richText"
                : item.form_tree_node_id
                ? "form"
                : item.canvas_tree_node_id
                ? "canvas"
                : item.attachment_tree_node_id
                ? "attachment"
                : null);
            return itemType === targetItemType;
          });

          if (targetByType) {
            const targetIndex = targetItems.indexOf(targetByType);
            if (targetIndex !== -1) {
              insertionIndex =
                moveType === "up" ? targetIndex : targetIndex + 1;
            }
          }
        }
      }
    }

    // Insert the moved item at the calculated position.
    targetItems.splice(insertionIndex, 0, itemToMove);
    updatedItems[targetContainerId] = targetItems;

    return updatedItems;
  };

  // Combine all content items for preview
  const allContentItems = {};

  Object.keys(updatedSteps).forEach((sectionId) => {
    updatedSteps[sectionId].forEach((step) => {
      const stepId = step.step_tree_node_id;

      // STEP-level content
      const stepContent = [
        ...(richTexts[stepId] || []).map((item) => ({
          ...item,
          type: "richText",
        })),
        ...(forms[stepId] || []).map((item) => ({
          ...item,
          type: "form",
        })),
        ...(attachments[stepId] || []).map((item) => ({
          ...item,
          type: "attachment",
        })),
        ...(canvases[stepId] || []).map((item) => ({
          ...item,
          type: "canvas",
        })),
        ...(videos[stepId] || []).map((item) => ({
          ...item,
          type: "video",
        })),
      ]
        .filter((item) => !item.substep_id_ref && !item.sub_step_tree_node_id)
        .sort((a, b) => {
          const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
          const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

          const orderCompare = compareSiblingOrders(orderA, orderB);
          if (orderCompare !== 0) return orderCompare;

          // Fallback: compare created_at
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateB - dateA; // latest comes first
        });

      allContentItems[stepId] = stepContent;

      // SUBSTEP-level content
      const substeps = substepsByStep[stepId] || [];
      substeps.forEach((substep) => {
        const substepId = substep.sub_step_tree_node_id;

        allContentItems[substepId] = [
          ...(richTexts[substepId] || []).map((item) => ({
            ...item,
            type: "richText",
          })),
          ...(forms[substepId] || []).map((item) => ({
            ...item,
            type: "form",
          })),
          ...(attachments[substepId] || []).map((item) => ({
            ...item,
            type: "attachment",
          })),
          ...(canvases[substepId] || []).map((item) => ({
            ...item,
            type: "canvas",
          })),
          ...(videos[substepId] || []).map((item) => ({
            ...item,
            type: "video",
          })),
        ].sort((a, b) => {
          const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
          const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

          const orderCompare = compareSiblingOrders(orderA, orderB);
          if (orderCompare !== 0) return orderCompare;

          // Fallback: compare created_at
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateB - dateA; // latest comes first
        });
      });
    });
  });

  // Add debugging for Attachment move positioning

  const updatedAllContentItems = getReorganizedContentItems(
    allContentItems,
    location.state.sourceStepId,
    location.state.targetStepId,
    location.state.sourceNodeIndex,
    location.state.targetNodeIndex,
    moveType,
    location.state.sourceNodeType?.toLowerCase() || "attachment"
  );
  const updatedAttachments = {};
  const updatedRichTexts = {};
  const updatedForms = {};
  const updatedVideos = {};
  const updatedCanvases = {};

  Object.entries(updatedAllContentItems).forEach(([containerId, items]) => {
    updatedAttachments[containerId] = items.filter(
      (i) => i.type === "attachment"
    );
    updatedRichTexts[containerId] = items.filter((i) => i.type === "richText");
    updatedForms[containerId] = items.filter((i) => i.type === "form");
    updatedVideos[containerId] = items.filter((i) => i.type === "video");
    updatedCanvases[containerId] = items.filter((i) => i.type === "canvas");
  });

  return (
    <div style={{ position: "relative" }}>
      {/* Main Page Loader */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div
              style={{
                border: "4px solid #f3f3f3",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                animation: "spin 1s linear infinite",
                marginBottom: "10px",
              }}
            ></div>
            <div style={{ fontSize: "16px", color: "#333" }}>
              {createCopy ? "Copying attachment..." : "Moving attachment..."}
            </div>
          </div>
        </div>
      )}
      <ProcedureMoveAppBar
        selectedView={selectedView}
        showBackButton={false}
        setSelectedView={handleViewChange}
        title={
          createCopy
            ? "Please Confirm the Changes"
            : "Please Confirm the Changes"
        }
        buttons={[{ label: "Confirm", onClick: handleConfirm }]}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "8px 20px",
          flexWrap: "wrap", // for responsiveness
        }}
      >
        {/* Checkbox + Title + Description */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              margin: 0,
            }}
          >
            {/* <input type="checkbox" disabled={true} checked={false} /> */}
            <span style={{ fontSize: "20px", fontWeight: 600 }}>
              {type} {partNumber}
            </span>
          </label>

          {/* Description */}
        </div>

        {/* Right-aligned section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginLeft: "auto",
          }}
        >
          <div>
            <strong>Status: </strong>
            <span style={{ color: "orange" }}>{location.state.status}</span>
            {/* <span style={{ color: "orange" }}>{status}</span> */}
          </div>

          <div>
            <strong>Revision: </strong>
            <span>{revision}</span>
          </div>
        </div>
      </div>
      <div style={{ padding: "20px" }}>
        <div style={{ marginTop: "20px" }}>
          {previewSections.map((section, index) => {
            return (
              <div
                key={section.section_tree_node_id}
                style={{
                  margin: "20px 0",
                  clear: "both",
                }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    clear: "both",
                  }}
                >
                  <h2 style={{ margin: 0 }}>Section {index + 1}</h2>
                </label>
                <hr />
                <hr />
                <div>{section.section_name}</div>
                <div>{section.short_description}</div>

                {/* Steps for this section */}
                {(updated[section.section_tree_node_id] || []).map(
                  (step, stepIndex) => {
                    const stepId = step.step_tree_node_id;
                    const sectionId = section.section_tree_node_id;
                    stepCounter++;
                    const stepsBeforeThisSection = previewSections
                      .slice(0, index)
                      .reduce(
                        (acc, s) =>
                          acc + (updated[s.section_tree_node_id]?.length || 0),
                        0
                      );
                    const globalStepNumber =
                      stepsBeforeThisSection + stepIndex + 1;

                    const substeps = updatedSubstepsByStep[stepId] || [];

                    const substepLetter = String.fromCharCode(
                      65 + substeps.length
                    ); // A, B, C...

                    // Calculate media counters before navigation
                    const currentAttachmentCounter = attachmentCounter;
                    const currentVideoCounter = videoCounter;
                    const currentFormCounter = formCounter;
                    const currentCanvasCounter = canvasCounter;
                    const currentRichTextCounter = richTextCounter;

                    // Update counters for next step
                    //attachmentCounter += myAttachments.length;
                    // videoCounter += myVideos.length;
                    // formCounter += myForms.length;
                    // canvasCounter += myCanvases.length;
                    // richTextCounter += myRichTexts.length; // If you're adding one richText per step

                    richTextsCounter[stepId] = currentRichTextCounter;

                    // Choose which data to display based on selectedView
                    const displayedRichTexts =
                      selectedView === "new" ? updatedRichTexts : richTexts;
                    const displayedForms =
                      selectedView === "new" ? updatedForms : forms;
                    const displayedAttachments =
                      selectedView === "new" ? updatedAttachments : attachments;
                    const displayedCanvases =
                      selectedView === "new" ? updatedCanvases : canvases;
                    const displayedVideos =
                      selectedView === "new" ? updatedVideos : videos;

                    // Use the selected content arrays for preview
                    const combinedItems =
                      selectedView === "new"
                        ? updatedAllContentItems[stepId] || []
                        : allContentItems[stepId] || []; // Filter out substeps or unwanted items (same as your current filter)
                    const filteredItems = combinedItems.filter(
                      (item) =>
                        !item.substep_id_ref && !item.sub_step_tree_node_id
                    );

                    // Store the section index to use in the inner loop
                    // Use the visual section number (index + 1) minus 1 to get the correct tree path index
                    // This ensures tree paths show the correct section number that the user sees
                    const visualSectionNumber = index + 1;
                    const currentSectionIndex = visualSectionNumber - 1; // Convert to 0-based for tree path generation

                    // filteredItems.sort((a, b) => {
                    //   const orderA =
                    //     a.sibling_order || a.procedure_tree?.sibling_order;
                    //   const orderB =
                    //     b.sibling_order || b.procedure_tree?.sibling_order;

                    //   const orderCompare = compareSiblingOrders(orderA, orderB);
                    //   if (orderCompare !== 0) return orderCompare;

                    //   // Fallback: compare created_at
                    //   const dateA = new Date(a.created_at);
                    //   const dateB = new Date(b.created_at);
                    //   return dateB - dateA; // latest comes first
                    // });

                    return (
                      <div
                        key={stepId}
                        style={{ marginTop: "20px", clear: "both" }}
                      >
                        <label>
                          <HeadingWithTreePath
                            title={`Step ${globalStepNumber}`}
                            treePathParams={{
                              sectionIndex: currentSectionIndex,
                              stepIndex: globalStepNumber - 1,
                              substepIndex: undefined,
                              nodeType: undefined,
                              nodeIndex: undefined,
                            }}
                          >
                            {location.state.movingStep &&
                              steps &&
                              steps.length > 0 &&
                              (step.step_tree_node_id ===
                                steps[0].step_tree_node_id ||
                                (section.section_tree_node_id ===
                                  sortedSections[targetSectionIndex]
                                    ?.section_tree_node_id &&
                                  ((moveType === "up" &&
                                    stepIndex === targetStepIndex) ||
                                    (moveType === "below" &&
                                      stepIndex === targetStepIndex + 1) ||
                                    (moveType === "into" &&
                                      stepIndex ===
                                        (
                                          updated[
                                            section.section_tree_node_id
                                          ] || []
                                        ).length -
                                          1)))) && (
                                <span
                                  style={{
                                    fontSize: "14px",
                                    color: "#007bff",
                                    marginLeft: "10px",
                                    fontStyle: "italic",
                                  }}
                                >
                                  {step.step_tree_node_id ===
                                  location.state.fromStepId
                                    ? "(Moving)"
                                    : "(New Position)"}
                                </span>
                              )}
                          </HeadingWithTreePath>
                        </label>
                        <hr />
                        <p style={{ whiteSpace: 'pre-wrap' }}>{step.short_description || ""}</p>
                        <p>
                          <p>
                            {structuredClone(step.step_details)
                              .sort(
                                (a, b) =>
                                  new Date(a.created_at) -
                                  new Date(b.created_at)
                              )
                              .map((myStep) => {
                                const partNumber =
                                  myStep.part_info?.part_number || "";
                                const description =
                                  myStep.part_info?.description || "";
                                const qtyText =
                                  myStep.qty && myStep.qty != 0
                                    ? `Qty ${myStep.qty}`
                                    : "";

                                const partText = partNumber
                                  ? ` (${partNumber})`
                                  : "";

                                return (
                                  <>
                                    {myStep.action}
                                    {partText}{" "}
                                    <RenderHtml content={description} />{" "}
                                    {qtyText}&nbsp;
                                  </>
                                );
                              })}
                          </p>
                        </p>

                        <h4>
                          {step.bom_table_title_info?.category_name || ""}
                        </h4>

                        <table className="table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>
                                {
                                  step.part_number_column_title_ref_info
                                    ?.category_name
                                }{" "}
                              </th>
                              <th>Description</th>
                              <th>Qty Per</th>
                              <th>Unit</th>
                            </tr>
                          </thead>

                          <tbody>
                            {step.parts_required.map((row) => (
                              <tr>
                                <td>{row.part_info.type_info.name}</td>
                                <td>{row.part_info.part_number}</td>
                                <td>
                                  <RenderHtml
                                    content={row.part_info.description}
                                  />{" "}
                                </td>
                                <td>{row.qty === 0 ? "" : row.qty}</td>
                                <td>{row.part_info?.unit_info?.unit_name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Step Content */}

                        {filteredItems.map((item, index) => {
                          if (item.substep_id_ref || item.sub_step_tree_node_id)
                            return null;
                          switch (item.type) {
                            case "richText": {
                              const globalRichTextNumber = richTextCounter++; // ✅ use then increment
                              // render richText block here
                              const label = (
                                <HeadingWithTreePath
                                  title={`Rich Text ${globalRichTextNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "richText",
                                    nodeIndex: globalRichTextNumber - 1,
                                  }}
                                />
                              );

                              return (
                                <div
                                  key={
                                    item.rich_text_node_id ||
                                    `richText-${globalRichTextNumber}`
                                  }
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <div
                                    style={{
                                      marginLeft: "5px",
                                      marginTop: "-10px",
                                      clear: "both",
                                    }}
                                  >
                                    {item.short_description}
                                  </div>
                                  {item.category_data && (
                                    <div
                                      style={{
                                        marginLeft: "4px",
                                        marginTop: "10px",
                                        clear: "both",
                                      }}
                                    >
                                      {item.category_data?.category_name}
                                    </div>
                                  )}
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                      clear: "both",
                                    }}
                                  >
                                    <div
                                      style={{
                                        marginTop: "-6px",
                                        clear: "both",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: item.rich_text_content,
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            }
                            case "video": {
                              const globalVideoNumber = videoCounter++; // ✅ use then increment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Video ${globalVideoNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "video",
                                    nodeIndex: globalVideoNumber - 1,
                                  }}
                                />
                              );

                              return (
                                <div
                                  key={
                                    item.video_tree_node_id ||
                                    `video-${globalVideoNumber}`
                                  }
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  {renderVideo(item)}

                                  <div>{item.video_url}</div>

                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }

                            case "form": {
                              const globalFormNumber = formCounter++; // ✅ use then increment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Form ${globalFormNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "form",
                                    nodeIndex: globalFormNumber - 1,
                                  }}
                                />
                              );
                              // render form block here
                              return (
                                <div
                                  key={
                                    item.form_tree_node_id ||
                                    `form-${globalFormNumber}`
                                  }
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      marginTop: "20px",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>
                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }
                            case "canvas": {
                              const pages = getPages(item);

                              const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Canvas ${globalCanvasNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "canvas",
                                    nodeIndex: globalCanvasNumber - 1,
                                  }}
                                />
                              );
                              const shapes = item.shapes || [];

                              return (
                                <div
                                  key={
                                    item.canvas_tree_node_id ||
                                    `canvas-${globalCanvasNumber}`
                                  }
                                  style={{ marginTop: "40px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <div>{item.short_description}</div>

                                  {/* Display all pages vertically */}
                                  <CanvasDisplay
                                    pages={pages}
                                    hasUserContent={hasUserContent}
                                    getTextStyle={getTextStyle}
                                    stripHtmlPreserveFormatting={
                                      stripHtmlPreserveFormatting
                                    }
                                    estimateKonvaTextHeight={
                                      estimateKonvaTextHeight
                                    }
                                    formatListContent={formatListContent}
                                    hasNoteContent={hasNoteContent}
                                    hasTaskContent={hasTaskContent}
                                    calculateGroupHeight={calculateGroupHeight}
                                    calculateTextBlockWidth={
                                      calculateTextBlockWidth
                                    }
                                  />
                                </div>
                              );
                            }
                            case "attachment": {
                              const attachmentList = item.attachments || [];
                              if (attachmentList.length === 0) return null;

                              //  const globalAttachmentNumber =
                              //           attachmentCounter++; // ✅ use then increment
                              const globalAttachmentNumber =
                                attachmentCounter++; // ✅ Increment here per attachment
                              // Find the local index of this attachment within the current step
                              const attachmentItems = filteredItems.filter(
                                (item) => item.type === "attachment"
                              );
                              const localAttachmentIndex =
                                attachmentItems.findIndex(
                                  (attachment) =>
                                    attachment.attachment_tree_node_id ===
                                    item.attachment_tree_node_id
                                );
                              const label = (
                                <HeadingWithTreePath
                                  title={`Attachment ${globalAttachmentNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "attachment",
                                    nodeIndex: globalAttachmentNumber - 1,
                                  }}
                                />
                              );

                              return (
                                <div
                                  key={
                                    item.attachment_tree_node_id ||
                                    `attachment-${globalAttachmentNumber}-${index}`
                                  }
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      marginTop: "20px",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>
                                  <div>{item.short_description}</div>
                                  {attachmentList.map((attachment, i) => (
                                    <div
                                      key={`${
                                        item.attachment_tree_node_id ||
                                        `attachment-${globalAttachmentNumber}`
                                      }-${i}`}
                                      style={{
                                        marginLeft: "20px",
                                        clear: "both",
                                      }}
                                    >
                                      {renderPreview(attachment)}
                                    </div>
                                  ))}
                                </div>
                              );
                            }
                            default:
                              return null;
                          }
                        })}

                        {/* Substeps */}
                        {(updatedSubstepsByStep[stepId] || []).map(
                          (substep, substepIndex) => {
                            const substepId = substep.sub_step_tree_node_id;
                            // Choose content based on view mode
                            const combinedItems =
                              selectedView === "new"
                                ? updatedAllContentItems[substepId] || []
                                : allContentItems[substepId] || [];

                            const filteredItems = combinedItems;

                            // Global step number calculation based on the updated steps data
                            const stepsBeforeThisOne =
                              previewSections
                                .slice(0, index)
                                .reduce((sectionAcc, s) => {
                                  const steps =
                                    updated[s.section_tree_node_id] || [];
                                  return sectionAcc + steps.length;
                                }, 0) + stepIndex;

                            const globalStepNumber = stepsBeforeThisOne + 1;

                            // Final substep label like Substep 5A
                            const substepLetter = String.fromCharCode(
                              65 + substepIndex
                            ); // A, B, C, ...

                            const globalSubstepLabel = `Substep ${globalStepNumber}${substepLetter}`;

                            return (
                              <div
                                key={substepId}
                                style={{ marginTop: "20px", clear: "both" }}
                              >
                                <label
                                  style={{
                                    display: "flex",
                                    gap: "8px",
                                    cursor: "pointer",
                                    clear: "both",
                                  }}
                                >
                                  <HeadingWithTreePath
                                    title={globalSubstepLabel}
                                    treePathParams={{
                                      sectionIndex: currentSectionIndex,
                                      stepIndex: globalStepNumber - 1,
                                      substepIndex: substepIndex,
                                      nodeType: undefined,
                                      nodeIndex: undefined,
                                    }}
                                  />
                                </label>
                                <div style={{ whiteSpace: 'pre-wrap' }}>{substep.short_description}</div>

                                {/* Substep Rich Texts */}
                                {filteredItems.map((item, itemIndex) => {
                                  switch (item.type) {
                                    case "richText": {
                                      const globalRichTextNumber =
                                        richTextCounter++; // ✅ use then increment
                                      // render richText block here
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Rich Text ${globalRichTextNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "richText",
                                            nodeIndex: globalRichTextNumber - 1,
                                          }}
                                        />
                                      );

                                      return (
                                        <div
                                          key={
                                            item.rich_text_node_id ||
                                            `richText-${globalRichTextNumber}`
                                          }
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              marginLeft: "5px",
                                              marginTop: "-10px",
                                              clear: "both",
                                            }}
                                          >
                                            {item.short_description}
                                          </div>
                                          {item.category_data && (
                                            <div
                                              style={{
                                                marginLeft: "4px",
                                                marginTop: "10px",
                                                clear: "both",
                                              }}
                                            >
                                              {
                                                item.category_data
                                                  ?.category_name
                                              }
                                            </div>
                                          )}
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              marginLeft: "4px",
                                              marginTop: "5px",
                                              clear: "both",
                                            }}
                                          >
                                            <div
                                              style={{
                                                marginTop: "-6px",
                                                clear: "both",
                                              }}
                                              dangerouslySetInnerHTML={{
                                                __html: item.rich_text_content,
                                              }}
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                    case "video": {
                                      const globalVideoNumber = videoCounter++; // ✅ use then increment
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Video ${globalVideoNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "video",
                                            nodeIndex: globalVideoNumber - 1,
                                          }}
                                        />
                                      );

                                      return (
                                        <div
                                          key={
                                            item.video_tree_node_id ||
                                            `video-${globalVideoNumber}`
                                          }
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          {renderVideo(item)}

                                          <div>{item.video_url}</div>

                                          <div>{item.short_description}</div>
                                        </div>
                                      );
                                    }

                                    case "form": {
                                      const globalFormNumber = formCounter++; // ✅ use then increment
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Form ${globalFormNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "form",
                                            nodeIndex: globalFormNumber - 1,
                                          }}
                                        />
                                      );
                                      // render form block here
                                      return (
                                        <div
                                          key={
                                            item.form_tree_node_id ||
                                            `form-${globalFormNumber}`
                                          }
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              marginTop: "20px",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>
                                          <div>{item.short_description}</div>
                                        </div>
                                      );
                                    }
                                    case "canvas": {
                                      const pages = getPages(item);

                                      const globalCanvasNumber =
                                        canvasCounter++; // ✅ use then increment
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Canvas ${globalCanvasNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "canvas",
                                            nodeIndex: globalCanvasNumber - 1,
                                          }}
                                        />
                                      );
                                      const shapes = item.shapes || [];

                                      return (
                                        <div
                                          key={
                                            item.canvas_tree_node_id ||
                                            `canvas-${globalCanvasNumber}`
                                          }
                                          style={{
                                            marginTop: "40px",
                                            clear: "both",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div>{item.short_description}</div>

                                          {/* Display all pages vertically */}
                                          <CanvasDisplay
                                            pages={pages}
                                            hasUserContent={hasUserContent}
                                            getTextStyle={getTextStyle}
                                            stripHtmlPreserveFormatting={
                                              stripHtmlPreserveFormatting
                                            }
                                            estimateKonvaTextHeight={
                                              estimateKonvaTextHeight
                                            }
                                            formatListContent={
                                              formatListContent
                                            }
                                            hasNoteContent={hasNoteContent}
                                            hasTaskContent={hasTaskContent}
                                            calculateGroupHeight={
                                              calculateGroupHeight
                                            }
                                            calculateTextBlockWidth={
                                              calculateTextBlockWidth
                                            }
                                          />
                                        </div>
                                      );
                                    }
                                    case "attachment": {
                                      const attachmentList =
                                        item.attachments || [];
                                      if (attachmentList.length === 0)
                                        return null;

                                      //  const globalAttachmentNumber =
                                      //           attachmentCounter++; // ✅ use then increment
                                      const globalAttachmentNumber =
                                        attachmentCounter++; // ✅ Increment here per attachment
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Attachment ${globalAttachmentNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "attachment",
                                            nodeIndex:
                                              globalAttachmentNumber - 1,
                                          }}
                                        />
                                      );

                                      return (
                                        <div
                                          key={
                                            item.attachment_tree_node_id ||
                                            `substep-attachment-${globalAttachmentNumber}`
                                          }
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              marginTop: "20px",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>
                                          <div>{item.short_description}</div>
                                          {attachmentList.map(
                                            (attachment, i) => (
                                              <div
                                                key={`${
                                                  item.attachment_tree_node_id ||
                                                  `substep-attachment-${globalAttachmentNumber}`
                                                }-${i}`}
                                                style={{
                                                  marginLeft: "20px",
                                                  clear: "both",
                                                }}
                                              >
                                                {renderPreview(attachment)}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      );
                                    }
                                    default:
                                      return null;
                                  }
                                })}
                              </div>
                            );
                          }
                        )}
                      </div>
                    );
                  }
                )}
              </div>
            );
          })}
        </div>
      </div>
      {/* Remove old loader position */}
      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content_addsection">
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <h4
                style={{
                  marginLeft: "23px",
                  fontSize: "18px",
                  color: "#333333",
                }}
              >
                {createCopy
                  ? generateConfirmMoveMessage({
                      locationState: location.state,
                      nodeType: "Attachment",
                      moveType,
                      sourceStepIndex,
                      targetStepIndex,
                      targetSectionData,
                      sourceSectionIndex,
                      targetSectionIndex,
                    }).replace("Confirm Move", "Confirm Copy")
                  : generateConfirmMoveMessage({
                      locationState: location.state,
                      nodeType: "Attachment",
                      moveType,
                      sourceStepIndex,
                      targetStepIndex,
                      targetSectionData,
                      sourceSectionIndex,
                      targetSectionIndex,
                    })}
              </h4>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#666",
                }}
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div
              style={{ padding: "24px", marginTop: "-28px", color: "#333333" }}
            >
              <h4 style={{ fontSize: "14px" }}>
                For {type} {partNumber} - Rev {revision}
              </h4>

              <p style={{ fontSize: "14px", color: "#333333" }}>
                <strong>Editor:</strong>{" "}
                <span style={{ marginLeft: "10px" }}>
                  {localStorage.getItem("user_name")}
                </span>
              </p>

              <label
                className="modal-label"
                style={{ fontSize: "14px", color: "#333333" }}
              >
                Comment<span className="required">*</span>
              </label>
              <textarea
                className="modal-textarea"
                placeholder="Enter your comments here..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{
                  width: "100%",
                  minHeight: "100px",
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
                disabled={isModalLoading}
              ></textarea>
            </div>

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                padding: "16px 24px",
                borderTop: "1px solid #e0e0e0",
                marginTop: "-10px",
                position: "relative",
              }}
            >
              {isModalLoading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    zIndex: 10,
                  }}
                >
                  <div
                    className="loader-spinner"
                    style={{
                      border: "4px solid #f3f3f3",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      animation: "spin 1s linear infinite",
                      marginRight: "10px",
                    }}
                  ></div>
                  <span>Processing...</span>
                </div>
              )}
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#6c757d",
                  color: "#e9ecef",
                  cursor: isModalLoading ? "not-allowed" : "pointer",
                }}
                disabled={isModalLoading}
              >
                Close
              </button>
              <button
                onClick={handleConfirmSave}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #007bff",
                  borderRadius: "4px",
                  background: "#007bff",
                  color: "white",
                  cursor: isModalLoading ? "not-allowed" : "pointer",
                  opacity: isModalLoading ? 0.7 : 1,
                }}
                disabled={isModalLoading}
              >
                {isModalLoading
                  ? createCopy
                    ? "Copying..."
                    : "Moving..."
                  : createCopy
                  ? "Copy"
                  : "Move"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProcedureAttachmentMovePreview;
